export const sliceTextAddEllipsis = (text, maxLengthDefault) => {
  if (text && text.length > maxLengthDefault) {
    return `${text.substring(0, maxLengthDefault)}...`;
  }

  return text;
};
